// extracted by mini-css-extract-plugin
export default {"root":"IconGroup_root__3N-d6"};